import PolicyValue from "./PolicyValue";
export default PolicyValue;
